import React, { useEffect, useState } from 'react';
import { buttons } from 'seal-ui-components';
import store from '@Store';
import mixpanelEvents from '@Mixpanel';
import { DOCUMENT_MARKUP } from '@Constants/types';
import { addContentControlBindings, getCCCount } from '@Service/wordApiService';
import { STORAGE_TYPE, getFromStorage } from '@Service/storageService';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import DialogPopUp from '@Components/UI/DialogPopUp/DialogPopUp';
import { Title, PopupInner, BodyText, ButtonsContainer } from './ProcessingDialog.style';

const modalHeaderProcess = 'Document markup';

const ProcessingDialog = ({
    className,
    modalHeader = modalHeaderProcess,
    isDialogHidden,
    closeDialog
}) => {
    const modalProps = { isDarkOverlay: true, isBlocking: true };
    const dialogContentProps = { className: `${className} processing-modal` };
    // const { remainingItems } = useSelector(state => state.document);
    const [itemsRemaining, setItemsRemaining] = useState(0);

    const getActualCCCount = () => {
        getCCCount().then(count => {
            const rootReducer = store.getState();
            const { document } = rootReducer;
            const { lastCount } = document;
            if (lastCount > 0 && lastCount === count) {
                addLog(
                    LOG_TYPE.INFO,
                    'ProcessingDialog.startEventHandlerBindingWhenReady',
                    'Starting the bindings now'
                );
                addContentControlBindings();

                store.dispatch({
                    type: DOCUMENT_MARKUP.SET_LAST_COUNT,
                    payload: 0
                });

                return;
            }

            store.dispatch({
                type: DOCUMENT_MARKUP.SET_LAST_COUNT,
                payload: count
            });

            setTimeout(() => getActualCCCount(), 5000);
        });
    };

    const checkProgress = () => {
        const rootReducer = store.getState();
        const { document } = rootReducer;
        const {
            mappedParagraphsScorecard,
            mappedParagraphsScorecard2,
            mappedParagraphsLabels,
            mappedParagraphsLabels2,
            isMarkupCancelling,
            totalItems
        } = document;

        let { markUpInProgress } = document;

        const total =
            mappedParagraphsScorecard.length +
            mappedParagraphsScorecard2.length +
            mappedParagraphsLabels.length +
            mappedParagraphsLabels2.length;

        setItemsRemaining(total);

        if (totalItems === 0 && total > 0) {
            store.dispatch({
                type: DOCUMENT_MARKUP.SET_TOTAL_ITEMS,
                payload: total
            });
        }

        // corner case
        if (
            total > 0 &&
            (markUpInProgress === 'ClickEventHandlersInProgress' ||
                markUpInProgress === 'ClickEventHandlersComplete')
        ) {
            addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', 'Corner case');
            // markup still in-progress therefore the event cannot be set yet
            store.dispatch({
                type: DOCUMENT_MARKUP.MARKUP_RUNNING,
                payload: 'Compared'
            });

            markUpInProgress = 'Compared';
        }

        store.dispatch({
            type: DOCUMENT_MARKUP.MARKUP_PROGRESS,
            payload: total
        });

        addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', `total = ${total}`);
        addLog(
            LOG_TYPE.INFO,
            'ProcessingDialog.checkProgress',
            `isMarkupCancelling = ${isMarkupCancelling}`
        );
        addLog(
            LOG_TYPE.INFO,
            'ProcessingDialog.checkProgress',
            `markUpInProgress = ${markUpInProgress}`
        );

        const markupOp = getFromStorage('MarkupOperation', STORAGE_TYPE.PROPERTY_BAG);
        addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', `markupOp = ${markupOp}`);

        /* Start of... CANCELLING */
        if (
            isMarkupCancelling === true &&
            markUpInProgress !== 'Comparing' &&
            markUpInProgress !== 'NotStarted'
        ) {
            store.dispatch({
                type: DOCUMENT_MARKUP.MARKUP_RUNNING,
                payload: 'NotStarted'
            });

            addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', 'Closing dialog1');
            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_CANCEL_FLAG, payload: false });
            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_RUNNING, payload: 'NotStarted' });
            closeDialog();
            return;
        }
        /* End of... CANCELLING */

        /* Start of... Check if MISSES is completing */
        if (total === 0 && markUpInProgress === 'Compared' && markupOp === 'misses') {
            // dont check immediately.  wait 1 second and re-check
            setTimeout(() => {
                addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', 'Check now...');
                const rootReducer2 = store.getState();
                const { document: doc } = rootReducer2;
                const {
                    mappedParagraphsScorecard: paragraphsScorecard,
                    mappedParagraphsScorecard2: paragraphsScorecard2,
                    mappedParagraphsLabels: paragraphsLabels,
                    mappedParagraphsLabels2: paragraphsLabels2
                } = doc;
                const total2 =
                    paragraphsScorecard.length +
                    paragraphsScorecard2.length +
                    paragraphsLabels.length +
                    paragraphsLabels2.length;

                if (total2 === 0) {
                    addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', 'Closing dialog2');
                    store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_CANCEL_FLAG, payload: false });
                    store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_RUNNING, payload: 'NotStarted' });
                    closeDialog();
                    return;
                }
            }, 10000); // set to 10 seconds, because on some systems can take up to 5 seconds to store the reverse-search data
        }
        /* End of... Check if MISSES is completing */

        /* Start of... Event handler setup */
        if (
            total === 0 &&
            markUpInProgress === 'Compared' &&
            markupOp === 'hits' &&
            isMarkupCancelling === false
        ) {
            store.dispatch({
                type: DOCUMENT_MARKUP.MARKUP_RUNNING,
                payload: 'ClickEventHandlersInProgress'
            });

            addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', `Total Items = ${totalItems}`);

            store.dispatch({
                type: DOCUMENT_MARKUP.SET_LAST_COUNT,
                payload: 0
            });

            setTimeout(() => getActualCCCount(), 500);
        }
        /* End of... Event handler setup */
        //
        /* Start of... Event Handler setup completion */
        if (
            total === 0 &&
            markUpInProgress === 'ClickEventHandlersComplete' &&
            markupOp === 'hits' &&
            isMarkupCancelling === false
        ) {
            addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', 'Bindings added');
            addLog(LOG_TYPE.INFO, 'ProcessingDialog.checkProgress', 'Closing dialog3');

            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_CANCEL_FLAG, payload: false });
            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_RUNNING, payload: 'NotStarted' });
            store.dispatch({ type: DOCUMENT_MARKUP.PROCESSING_DIALOG_VISIBLE, payload: false });
            mixpanelEvents.markupCCDone();
            closeDialog();
            mixpanelEvents.markupEventsBindingDone();

            return;
        }
        /* End of... Event Handler setup completion */

        setTimeout(() => checkProgress(), 5000);
    };

    useEffect(
        () => {
            if (!isDialogHidden) {
                addLog(
                    LOG_TYPE.INFO,
                    'ProcessingDialog.useEffect[isDialogHidden]',
                    'Calling checkProgress'
                );

                setTimeout(() => checkProgress(), 10000);
            }
        },
        [isDialogHidden]
    );

    const rootReducer = store.getState();
    const { document } = rootReducer;
    const { markUpInProgress, isMarkupCancelling } = document;
    const operation = getFromStorage('MarkupOperation', STORAGE_TYPE.PROPERTY_BAG);

    const handleCloseModal = () => {
        addLog(
            LOG_TYPE.INFO,
            'ProcessingDialog.handleCloseModal',
            `markUpInProgress = ${markUpInProgress}`
        );

        // only allow close then the compare operation is complete
        if (markUpInProgress === 'Compared' || markUpInProgress === 'ClickEventHandlersComplete') {
            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_CANCEL_FLAG, payload: true });
            store.dispatch({ type: DOCUMENT_MARKUP.CLEAR_BACKGROUND_PROCESS_DATA });
            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_RUNNING, payload: 'NotStarted' });

            // addContentControlBindings();
            addLog(LOG_TYPE.INFO, 'ProcessingDialog.handleCloseModal', 'Closing dialog1');
            closeDialog();
        }

        if (markUpInProgress === 'ClickEventHandlersInProgress') {
            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_CANCEL_FLAG, payload: true });
            store.dispatch({ type: DOCUMENT_MARKUP.CLEAR_BACKGROUND_PROCESS_DATA });
            store.dispatch({ type: DOCUMENT_MARKUP.MARKUP_RUNNING, payload: 'NotStarted' });
            addLog(LOG_TYPE.INFO, 'ProcessingDialog.handleCloseModal', 'Closing dialog2');
            closeDialog();
        }
    };

    let message = '';
    if (isMarkupCancelling) {
        message = 'Cancelling...';
    } else {
        /* eslint-disable no-lonely-if */
        if (markUpInProgress === 'Compared') {
            message = itemsRemaining === 0 ? 'Please wait...' : `${itemsRemaining} remaining`;
        } else if (
            (markUpInProgress === 'ClickEventHandlersInProgress' ||
                markUpInProgress === 'ClickEventHandlersComplete') &&
            operation === 'hits'
        ) {
            message = 'Nearly done...';
        } else {
            message = 'Please wait...';
        }
    }

    return (
        <DialogPopUp
            hidden={isDialogHidden}
            onDismiss={handleCloseModal}
            modalProps={modalProps}
            dialogContentProps={dialogContentProps}
            className="ms-dialog-loading"
        >
            <PopupInner>
                <Title className="ms-Dialog-title" data-testid="processing_header">
                    {modalHeader}
                </Title>
                <BodyText>{message}</BodyText>
                {(markUpInProgress === 'Compared' ||
                    markUpInProgress === 'ClickEventHandlersInProgress' ||
                    markUpInProgress === 'ClickEventHandlersComplete') && (
                    <ButtonsContainer className="processing-modal__action-buttons">
                        <buttons.Button
                            size="medium"
                            appearance="secondary"
                            data-testid="processing_cancel_button"
                            onClick={handleCloseModal}
                        >
                            Cancel
                        </buttons.Button>
                    </ButtonsContainer>
                )}
            </PopupInner>
        </DialogPopUp>
    );
};

export default ProcessingDialog;
